import axios from "axios";
import { timeoutSmall, timeoutStandart, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";
import { Encrypt } from "../Crypt";
import { handleApiError } from "./errorHandler";

export function GetCard() {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      var axios = require("axios");
      var config = {
        method: "get",
        url: getApiUrl(`/api/v1/Card/GetCard`),
        headers: {
          Authorization: "Bearer " + token,
        },
        timeout: timeoutSmall
      };
      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "obter cartões"));
        });
    });
  });
}

export function SaveCard(
  personName,
  document,
  cardNumber,
  expiringDate,
  cardBrand
) {
  const card = {
    person_name: personName,
    cpf_cnpj: document.replace(/\D/g, ""),
    number: cardNumber.replace(/ /g, ""),
    expiry_date: expiringDate,
    brand: cardBrand,
  };
  
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      let config = {
        method: "post",
        data: card,
        url: getApiUrl("/api/v1/Card/SaveCard"),
        timeout: timeoutStandart,
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "salvar cartão"));
        });
    });
  });
}

export function DeleteCard(idCard) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      let config = {
        method: "post",
        params: { "cdCard": Encrypt(idCard) },
        url: getApiUrl("/api/v1/Card/DeleteCard"),
        timeout: timeoutSmall,
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "excluir cartão"));
        });
    });
  });
}

export function GetPaymentMethods() {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      var axios = require("axios");
      var config = {
        method: "get",
        url: getApiUrl(`/api/v1/Wallet/GetPaymentMethods`),
        headers: {
          Authorization: "Bearer " + token,
        },
        timeout: timeoutSmall,
      };
      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "obter métodos de pagamento"));
        });
    });
  });
}